import React from 'react';

const OpenedBook = (props) => {
  return (
    <svg
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9372 18.287H11.1202C9.98907 17.4073 6.28142 15.9116 0.5 16.9674V3.01103L2.5 2.25"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0628 18.287H12.8798C14.0109 17.4073 17.7186 15.9116 23.5 16.9674V3.01103L21.25 2.25"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0149 16.0001V2.80646C8.73111 -0.477292 4.47006 0.539106 2.75 1.45777V14.71C6.59668 13.3027 10.5294 14.9837 12.0149 16.0001Z"
        fill="#2D293B"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0164 16.0001V2.80646C15.3001 -0.477292 19.5612 0.539106 21.2812 1.45777V14.71C17.4346 13.3027 13.5019 14.9837 12.0164 16.0001Z"
        fill="#2D293B"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8642 4.40422C15.4291 3.23611 17.6647 3.01255 19.4531 3.68323"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0577 4.33196C8.49281 3.16385 6.25722 2.94029 4.46875 3.61097"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8642 7.01457C15.4291 5.84646 17.6647 5.6229 19.4531 6.29359"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0577 6.94133C8.49281 5.77322 6.25722 5.54966 4.46875 6.22034"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8642 9.69719C15.4291 8.52908 17.6647 8.30552 19.4531 8.9762"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0577 9.62493C8.49281 8.45681 6.25722 8.23326 4.46875 8.90394"
        stroke="#8686f1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpenedBook;
